package com.vizio.redwolf.pay.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class OffersFailureResponse(
    val offerId: String? = null,
    val status: String? = null,
    val code: String? = null,
    val detail: String? = null,
    val traceId: String? = null,
    val message: String? = null
)